import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import LingkAdapterWriterForm from '../forms/lingk-adapter-writer-form';
import { lingkAdapterWriterValidationSchema } from '../schema/lingkAdapterWriter.js';

export default function LingkAdapterWriterNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Lingk Adapter Writer Node Details',
        altText: 'Lingk Adapter Writer Node',
        defaultLabel: 'Lingk Adapter Writer Node',
      }}
    >
      <CommonNode
        FormComponent={LingkAdapterWriterForm}
        schemaResolver={lingkAdapterWriterValidationSchema}
      />
    </NodeProvider>
  );
}
